<template>
  <!-- 权限申请配置页面 -->
  <mtd-row>
    <div v-if="apply_bpm_exist === 'TRUE'" style="margin-top: 16px;">
      <div class="page-title-22">您的申请还在审批中，可点击<a :href="apply_bpm_address" target="_blank">申请链接</a>查看审批状态
      </div>
    </div>
    <div v-else-if="apply_bpm_exist === 'FALSE'" style="margin-top: 16px;">
      <div class="page-title-22">您未申请页面访问权限，请先申请权限</div>
      <!-- Form -->
      <mtd-form :label-width="74" style="margin-top: 16px">
        <mtd-form-item label="申请人:">
          {{ login_user.mis }}
        </mtd-form-item>
        <mtd-form-item label="申请时长:">
          <mtd-input-number :value="form_data.effectiveDays" style="width: 150px;"
                            :min="1" :max="30" :precision="0" :formatter="effective_days_formatter"
                            :parser="effective_days_parser" @change="effective_days_change"/>
        </mtd-form-item>
        <mtd-form-item label="APP名称:">
          <mtd-select v-model="form_data.applyApp" placeholder="请选择APP" clearable style="width: 150px;"
                      key="applyAppId_select">
            <mtd-option v-for="item in application_list" :key="item.appId" :label="item.appName" :value="item"/>
          </mtd-select>
        </mtd-form-item>
        <mtd-form-item>
          <mtd-button type="primary" @click="submit_apply_modal" style="width: 82px;">申请</mtd-button>
        </mtd-form-item>
      </mtd-form>
    </div>
  </mtd-row>
</template>

<script>
  import {mapActions} from "vuex";
  import moment from "moment";
  import {BPM_STATUS} from "@/constants/bpm_file"

  export default {
    name: "permission_apply",
    filters: {},
    data() {
      return {
        form_data: {
          misId: null,
          effectiveDays: 10,
          applyApp: null,
          applyAppId: null,
          applyAppName: null
        },
        application_list: [],
        user_apply: null,
        apply_bpm_status: null,
        apply_bpm_address: null,
        apply_bpm_exist: null,
      }
    },
    computed: {
      login_user() {
        return this.$store.getters.get_login_user;
      },
    },
    mounted() {
      this.load_all_app_list();
      this.load_user_apply_data();
    },
    methods: {
      ...mapActions({
        'api_query_user_apply': 'api_mobile_protect_common_query_query_user_apply',
        'api_save_user_apply': 'api_mobile_protect_common_query_save_user_apply',
        'api_list_all_application': 'api_mobile_protect_app_list_all',
      }),
      load_all_app_list() {
        this.api_list_all_application().then((res) => {
          const code = res.code;
          if (code !== 0) {
            return;
          }
          this.application_list = res.data;
        });
      },
      load_user_apply_data() {
        this.api_query_user_apply().then((res) => {
          const {data} = res;
          if (!data) {
            this.apply_bpm_exist = 'FALSE';
            return;
          }
          this.user_apply = data;
          const {bpmStatus, bpmDetailUrl} = data;
          this.apply_bpm_status = bpmStatus;
          this.apply_bpm_address = bpmDetailUrl;
          this.apply_bpm_exist = 'TRUE';
        });
      },
      effective_days_formatter(num) {
        return `${num}天`;
      },
      effective_days_parser(num) {
        return num.replace('天', '');
      },
      effective_days_change(num) {
        this.form_data.effectiveDays = num;
      },
      submit_apply_modal() {
        const applyApp = this.form_data.applyApp;
        if (!applyApp) {
          this.$mtd.message.error("请选择APP");
          return;
        }
        const {appId, appName} = applyApp;
        this.form_data.applyAppId = appId;
        this.form_data.applyAppName = appName;
        this.api_save_user_apply(this.form_data).then(() => {
          this.load_user_apply_data();
        });
      }
    }
  }
</script>

<style scoped>
  .test-clear {
    clear: both;
  }
</style>
